module.exports = __webpack_public_path__ + "static/media/BM_Documents.2574f398.svg";